import { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import { IconWorld, IconArrowRight } from "@tabler/icons-react";
import { updateDoc } from "firebase/firestore";
import { useUsuario } from "../../../providers/usuarioProvider";
import UsuarioDb from "../../../db/usuarioDb";
import felixAnalytics from "../../../felixAnalytics";
import { useSnackBar } from "../../../stores/snackBarStores";

export default function DiscoveryInternacional() {
  const { visualizado } = useUsuario();
  const dispatchSnack = useSnackBar();
  const [ativando, setAtivando] = useState(false);

  useEffect(() => {
    if (visualizado) {
      felixAnalytics.identify(visualizado);
      felixAnalytics.track("viewed_intl_discovery");
    }
  }, [visualizado]);

  const ativar = async () => {
    if (!visualizado) return;
    felixAnalytics.identify(visualizado);
    felixAnalytics.track("clicked_intl_discovery_cta");
    setAtivando(true);
    try {
      await updateDoc(new UsuarioDb().doc({ usuarioId: visualizado }), {
        "preferencias.mercadoInternacional": true,
      });
      felixAnalytics.track("mercadoInternacional", { value: true });
    } catch (error) {
      console.log(error);
      setAtivando(false);
      dispatchSnack({
        type: "ALERT",
        payload: {
          mensagem: "Não foi possível ativar. Tente novamente.",
          severidade: "error",
        },
      });
    }
  };

  return (
    <Container maxWidth="sm" disableGutters>
      <Box textAlign="center" px={3} py={6}>
        {/* Ícone em accent-ink: `primary.main` como tinta reprova em WCAG no dark. */}
        <Box
          display="flex"
          justifyContent="center"
          mb={3}
          sx={(theme) => ({ color: theme.palette.accentInk })}
        >
          <IconWorld size={56} stroke={1.25} />
        </Box>
        <Typography variant="eyebrow" color="text.secondary" mb={2}>
          Ativos no exterior
        </Typography>
        {/* Assinatura da marca: palavra enfatizada em itálico accent. */}
        <Typography variant="display" color="text.primary" mb={2}>
          Mercado{" "}
          <Box
            component="em"
            sx={(theme) => ({
              fontStyle: "italic",
              color: theme.palette.accentInk,
            })}
          >
            Internacional
          </Box>
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          mb={4}
          sx={{ maxWidth: "42ch", mx: "auto" }}
        >
          Calcule o IR dos investimentos no exterior conforme a Lei{" "}
          <Typography
            component="span"
            variant="dataMono"
            sx={{ fontSize: "inherit" }}
          >
            14.754/2023
          </Typography>
          .
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={ativar}
          disabled={ativando}
          startIcon={ativando ? <CircularProgress size={16} color="inherit" /> : undefined}
          endIcon={!ativando ? <IconArrowRight size={20} /> : undefined}
        >
          {ativando ? "Ativando..." : "Ativar mercado internacional"}
        </Button>
        {/* Frase corrida não é rótulo: `caption` agora é mono UPPERCASE. */}
        <Typography
          variant="body2"
          color="text.secondary"
          display="block"
          mt={3}
        >
          Você pode desativar a qualquer momento em Conta › Preferências.
        </Typography>
      </Box>
    </Container>
  );
}
